import React from "react";
import { Button, Result } from "antd";
import * as Sentry from "@sentry/react";
import i18n from "../../../i18n";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Display fallback UI
    this.setState({ hasError: true });

    // Log error
    console.error(error);
    console.log(info);

    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Result
          status="500"
          title="500"
          subTitle={i18n.t("sorry_error_occurred")}
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              {i18n.t("reload")}
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
